import { createContext } from 'react';

export const ChooseAudienceManagementContext = createContext();
export const ManageCampaignsContext = createContext();
